<button class="btn pl-0 pr-0 font-reg d-flex justify-content-between align-items-center w-100" (click)="edit()">
  {{model.label}}<i class="btn fa fa-angle-right text-red font-md" aria-hidden="true"></i>
</button>
<ul (click)="edit()" class="pl-0 pt-1">
  <li *ngFor="let value of model.values" class="d-flex align-items-center justify-content-between w-100 text-opacity-7">
    {{formatLabel(value)}}
    <button type="button" class="btn pr-0 py-0" (click)="remove(value); $event.stopPropagation()" aria-title="Remove value">
      <i class="btn fa fa-times-circle text-red font-reg" aria-hidden="true"></i>
    </button>
  </li>
</ul>
